export const contracts = {
  multicall: {
    address: "0x29de9dfa4adfe50c878fb2ffff8c1b28d9e24355",
  },
  liquidityMiningManager: {
    address: "0x025aC173Fe1DdD43E435fd190334DEAA2249d3E2",
  },
  escrowedReward: {
    address: "0x0E70a889F879efe79544D8f5a046537f005B2028",
  },
  view: {
    address: "0xF455b05bfCeE4FF87e8ffd78B9F2752b3218B537",
  },
  singleTokenPool: {
    address: "0x87Ba0Db3f5A28c829f32C7561268e04177367D9C",
  },
  lpPool: {
    address: "0x78fcf2Af781dcF9c0f640185a133C2289528941A",
  },
  uniswapLpPairAddress : {
    address: "0x83eEF420C54B1B8D6FeF17625ca08e19E3eb1096"
  }
};
